import { BaseResourceService } from '/@/modules/core/app/services/abstracts/BaseResourceService';
import Logger from '/@/modules/core/app/helpers/Logger';
import { EstateDetailEvent } from '@/modules/ops/constants/EstateDetailEvent';
import EventBus from '@/modules/core/app/helpers/EventBus';

export class BaseFormService extends BaseResourceService {
  /**
   * @type {string}
   */
  primaryKey = 'id';

  /**
   * @abstract
   * @returns BaseModel
   */
  getModel() {
    Logger.log('getModel() must be implemented', Logger.LEVEL_ERROR);
  }

  /**
   * @abstract
   * @returns string
   */
  getRoute() {
    Logger.log('getRoute() must be implemented', Logger.LEVEL_ERROR);
  }

  /**
   * @param model
   * @returns BaseModel
   */
  getNewForm(model = {}) {
    return this.getModel().factory(model);
  }

  /**
   * @param id
   * @param params
   * @returns {Promise<*>}
   */
  async getForm(id, params = {}) {
    params = this.addParams(params ?? {});
    return this.resource.getItem(id, params);
  }

  /**
   * @param form
   * @returns {Promise<*>}
   */
  async submitForm(form) {
    let id = this.getPrimaryKeyValue(form);
    let dataPromise = this.resource.saveItem(this.preProcessFormData(form), id);

    try {
      let entity = this.getModel().mapModel(await dataPromise);
      const eventName = id
        ? EstateDetailEvent.formatEntityUpdatedModel(entity.getModelName())
        : EstateDetailEvent.formatEntityAddedModel(entity.getModelName());

      EventBus.signal(eventName, entity);
    } catch (e) {
      Logger.error(e.message);
    }

    return dataPromise;
  }

  /**
   * @param form
   */
  preProcessFormData(form) {
    return form;
  }

  /**
   * @returns {object}
   */
  addParams(params = {}) {
    return params;
  }

  /**
   * @param form
   * @returns {*}
   */
  getPrimaryKeyValue(form) {
    return form[this.primaryKey];
  }
}
